import { useParams } from 'react-router-dom'

import ReturnReceiptUploadSection from '../components/files/ReturnReceiptUploadSection'
import TableAttachments from '../components/table/files/TableAttachments'

const ProtocolBookAttachments = () => {
  const { id } = useParams()

  return (
    <div>
      <ReturnReceiptUploadSection fileId={id} />
      <TableAttachments primaryDocumentId={id} isOnProtocolBook />
    </div>
  )
}

export default ProtocolBookAttachments
